import { Col, Container, Row } from "react-bootstrap";

import { makeStyles } from "@material-ui/core/styles";
import { mediaQueries } from "shared/config/breakpoints";
import styled from "styled-components";

export const NavBarStyles = makeStyles(() => ({
    logo: {
        "&.MuiLink-root": {
            fontFamily: globalThis.config.fonts.families.medium,
            color: globalThis.config.colors.black,
            textDecoration: "none",
        },
    },
    tooltip: {
        fontSize: "0.65rem",
        padding: "3px 6px",
    },
    tooltipPlacementBottom: {
        marginTop: "15px",
        marginLeft: "50px",
    },
    navItem: {
        "&.MuiLink-root": {
            color: globalThis.config.colors.black,
            textDecoration: "none",
            display: "inline-block",
            height: "1.25rem",
            whiteSpace: "nowrap",
            marginLeft: "1.5em",
            flex: "0 1 auto",
            minWidth: 0,
            [mediaQueries.mediumSmall]: {
                marginLeft: "0.75em",
            },
            [mediaQueries.small]: {
                marginLeft: "0.5em",
                overflow: "hidden",
            },
            "& .MuiTypography-root": {
                [mediaQueries.medium]: {
                    fontSize: "0.75rem !important",
                },
                [mediaQueries.small]: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                },
                [mediaQueries.superSmall]: {
                    fontSize: "0.69rem !important",
                },
            },
        },
    },
}));

export const NavWrapper = styled.header`
    position: fixed;
    top: 0px;
    height: 50px;
    width: 100%;
    z-index: 999;
    background-color: ${globalThis.config.colors.gray8};
`;

export const NavContainer = styled(Container)`
    padding: 0;
    margin: 0;
`;

export const NavRow = styled(Row)`
    padding 0.813em 0 0 0;
    margin: 0;
`;

// On phones every pixel counts for the grouped nav triggers, so the indent and
// logo columns stop reserving fixed percentages. (The Bootstrap col-1 padding
// alone otherwise forces the indent to 30px.)
export const IndentColumn = styled(Col)`
    flex: 0 0 4%;
    ${mediaQueries.superSmall} {
        flex: 0 0 1rem;
        max-width: 1rem;
        padding: 0;
    }
`;

export const LogoColumn = styled(Col)`
    margin-top: 0.25rem;
    white-space: nowrap;
    padding: 0;
    ${mediaQueries.superSmall} {
        flex: 0 0 auto;
        width: auto;
        max-width: none;
    }
`;

export const NavColumn = styled(Col)`
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
    padding: 0;
`;

export const NavLinksGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
`;

export const ExternalLink = styled.a`
    display: inline-block;
    margin-left: 1.5em;
    color: ${globalThis.config.colors.black};
    text-decoration: none;
    white-space: nowrap;
    &:hover {
        color: ${globalThis.config.colors.black};
        text-decoration: none;
    }
`;

export const NavBarExternalLink = styled(ExternalLink)`
    ${mediaQueries.medium} {
        .MuiTypography-root {
            font-size: 0.75rem !important;
        }
    }
`;

export const UserProfileMenuWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-left: 1.5em;
    margin-right: 2em;
    ${mediaQueries.superSmall} {
        margin-left: 0.5rem;
        margin-right: 1rem;
    }
`;

export const EnvNameWrapper = styled.div`
    background-color: ${globalThis.config.colors.red1};
    color: ${globalThis.config.colors.white};
    margin: 0 2rem;
    display: inline-block;
    padding: 0 1rem;
    font-weight: bold;
    ${mediaQueries.medium} {
        font-size: 0.75rem;
        padding: 0 0.5rem;
        margin: 0 0.5rem;
    }
    /* On phones, tuck the badge under the logo instead of beside it so it
       doesn't take horizontal space from (or overlap) the nav triggers. */
    ${mediaQueries.superSmall} {
        position: absolute;
        left: 0;
        top: 1.2rem;
        margin: 0;
        padding: 0 0.2rem;
        font-size: 0.55rem;
        line-height: 0.75rem;
    }
`;
